<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Type Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Registration Type/Fee" label-position="inside">
                        <b-select expanded v-model="registration.conf_reg_types.id">
                            <option :value="t.id" v-for="t in types">{{t.title}}</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    import {client as http} from "@/http_client";

    export default {
        name: 'RegistrationForm',
        props: {
            registration: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                types: []
            };
        },
        methods: {
            load: function() {
                console.log(this.registration);
                http.get('conferences/' + this.registration.conference_id).then(response => {
                    this.types = response.data.regTypes;
                }).catch(err => {

                });
            }
        },
        mounted: function() {
               this.load();
        }
    };
</script>
